import * as React from 'react';
import { useState, useEffect } from 'react';
import { Row, Col, Label, Input } from 'reactstrap';
import Page from '../Page';
import { useAppSelector, useAppDispatch } from '../../hooks/index';
import { Entity, getSelectedEntity } from '../../redux/EntitySlice';
import { Concept, ConceptRef } from '../../redux/ConceptSlice';
import { ConceptNode } from '../../redux/AccountsSlice';
import { getSelectedTitles, getTitleValue } from '../../redux/TitleSlice';
import { Afr, getSelectedAfr, updateVersionStateValue, generateLocalStateFromEventProperties, getTable } from '../../redux/AfrSlice';
import { setIsDirty, isAdmin } from '../../redux/MiscSlice';
import FactEditor from '../feature/FactEditor';
import utilityHelper from '../../utils/utilityHelper';
import enums from '../../utils/enums';
import { AdminUserRoleEnum, selectAdminUserRole } from '../../redux/UserSlice';

const LongTermDebtCore = (props: { userRole: string }) => {

    const dispatch = useAppDispatch();
    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);
    const afrYear = currentAfr ? currentAfr.year : 0;
    const entity: Entity | null = useAppSelector(getSelectedEntity);
    const titleConcepts: ConceptNode[] | null = useAppSelector(getSelectedTitles);
    const [state, setState] = useState(generateLocalStateFromEventProperties(currentAfr, ["reviewState_debtReviewed"]));
    const [titleDocumentation, setTitleDocumentation] = useState<string[]>([]);
    const isAdminUser: boolean = useAppSelector(isAdmin);
    const adminUserRole: AdminUserRoleEnum | null = useAppSelector(selectAdminUserRole);
    const handleChangeCheckbox = function (event : any) {

        var checkValues = JSON.parse(JSON.stringify(state));
        var key: string = event.target.name;
        var value: boolean = event.target.checked
        checkValues[key] = value;

        setState(checkValues);

        // here call to dispatcher sending:
        var eventFirstlevel = key.split("_")[0]
        var eventSecondlevel = key.split("_")[1]

        // Update global flag for this event in redux
        dispatch(updateVersionStateValue({ propGroup: eventFirstlevel, propName: eventSecondlevel, boolValue: value, value: null }));

        // set the dirty flag to TRUE
        dispatch(setIsDirty({ IsDirty: true, Page: "" }))

    }

    useEffect(() => {
        // get state from redux
        var newLocalState = generateLocalStateFromEventProperties(currentAfr, ["reviewState_debtReviewed"])

        // create a local state from redux
        setState(newLocalState)

    }, [currentAfr])

    useEffect(() => {
        // get state from redux
        setTitleDocumentation(getTitleValue("UAS_005_LongTermDebtTitle", titleConcepts));
    }, [titleConcepts, currentAfr])


    return (
        <React.Fragment>
            <Page>
                {entity != null ? (<h2>Long-Term Debt for {utilityHelper.getEntityName(entity, currentAfr)} ({utilityHelper.getEntityCode(entity, currentAfr)}), {afrYear}</h2>) : (<></>)}
                
                {isAdminUser &&
                (<div className="box-events pl-2 pr-3 py-3 my-2">
                    <div>
                        <Label className="ml-4" check>
                            <Input type="checkbox"
                                name="reviewState_debtReviewed"
                                onChange={handleChangeCheckbox}
                                checked={state["reviewState_debtReviewed"]}
                                disabled={!utilityHelper.checkStatusList(currentAfr, enums.certifiedRecertified)}
                            /><b>Reviewed</b>
                        </Label>
                    </div>
                </div>)}
                <Row>
                    <Col>
                        <div>
                            {titleDocumentation.length === 0
                                ?
                                <h5>
                                    <p>Post the amount of outstanding long-term debt as of the fiscal year-end. Section 218.32(2)(b), Florida Statutes, defines long-term debt as "any agreement or series of agreements to pay money, which, at inception, contemplate terms of payment exceeding 1 year in duration".</p>
                                    <p style={{ color: 'red' }}>For AFR purposes, please exclude the following in the calculation of long-Term Debt
                                        <ul>
                                            <li>Compensated leave absences</li>
                                            <li>Other postemployment benefits (OPEB) liability</li>
                                            <li>Workers' compensation</li>
                                            <li>Unscheduled landfill closure liability</li>
                                            <li>Pensions, prepayments made after the close of the fiscal year being reported</li>
                                            <li>Current portion of the long-term debt (amount due within 1 year)</li>
                                        </ul>
                                    </p>
                                    <p style={{ color: '#2EBE6F' }}>For AFR purposes, please include the following in the calculation of Long-Term Debt:
                                        <ul>
                                            <li>Any bond discounts</li>
                                            <li>Any bond premiums</li>
                                        </ul>
                                    </p>
                                    <p>NOTE: If the entity has no outstanding long-term debt as of the fiscal year-end, you must enter 0.</p>
                                </h5>
                                :
                                <h5>
                                    {titleDocumentation.map((option: string, idx) => (
                                        <div key={idx + ""} dangerouslySetInnerHTML={{ __html: "<p>" + option + "</p>" }} ></div>
                                    ))}
                                </h5>
                            }
                            <FactEditor
                                tableName={enums.tableName.longTermDebt}
                                conceptId="LongTermDebt"
                                rowCode={enums.rowCode.longTermDebtAmount}
                                columnCode="period"
                                allowDecimals={false}
                                allowNegativeValue={false}
                                prefix="$"
                                disabled={utilityHelper.checkStatusList(currentAfr, enums.verifiedCertifiedRecertified)
                                    || (adminUserRole === AdminUserRoleEnum.Reviewer || adminUserRole === AdminUserRoleEnum.Admin)}
                                maxLength={11}
                                placeholder="Please enter a number."
                            />
                            <br/>
                            <h5 className="text-left">This amount does not include the amount due within one year.</h5>

                        </div>
                    </Col>
                </Row>
            </Page>
        </React.Fragment>
    );
}

export default LongTermDebtCore;